import 'normalize.css'
import 'vant/lib/index.css';
import '@/assets/css/style.scss'
import {validateAndInitVar} from '@/utils/validatePageParams.js'
import {setRem} from '@/utils/setHtmlFontSize.js'
import '@/utils/debug.js'
import './components.js'


validateAndInitVar();//初始化url参数和验证url必填参数  函数执行后全局可使用 window.PAGE_PATH和window.PAGE_PARAMS
setRem();

